import { BaseApiService } from './BaseApiService'

export interface PaymentIntentResponse {
  clientSecret: string
  paymentIntentId: string
  amount: number
}

export interface PaymentConfirmationResponse {
  success: boolean
  paymentIntentId: string
  amount: number
  message?: string
}

/**
 * Stripe Service
 *
 * Handles API calls related to Stripe payment processing,
 * including creating payment intents and confirming payments
 */
export class StripeService extends BaseApiService {
  /**
   * Create a payment intent for the top-up amount
   */
  async createPaymentIntent(
    amount: number,
    enableAutoTopup: boolean = false,
    autoTopupThreshold: number = 5,
    autoTopupAmount: number = 5,
    currency: string
  ): Promise<PaymentIntentResponse> {
    // Convert amounts to cents for Stripe
    const amountInCents = Math.round(amount * 100)
    const thresholdInCents = Math.round(autoTopupThreshold * 100)
    const autoTopupAmountInCents = Math.round(autoTopupAmount * 100)
    // We can tune this as we need
    const idempotencyKey = crypto.randomUUID()

    return this.post<PaymentIntentResponse>('/stripe/payment-intent', {
      amount: amountInCents,
      currency,
      enableAutoTopup,
      autoTopupThreshold: thresholdInCents,
      autoTopupAmount: autoTopupAmountInCents,
    }, {
      requiresAuth: true,
      headers: {
        'Idempotency-Key': idempotencyKey
      }
    })
  }
}

// Singleton instance
export const stripeService = new StripeService()
